import CssBaseline from '@mui/material/CssBaseline'
import * as React from 'react'

const Baseline = () => {
  return <CssBaseline />
}

export default Baseline
